const DEFAULT_LANGUAGE = 'en';
const TRACKING = 'SIGNUP';

export { DEFAULT_LANGUAGE, TRACKING };
